
import Vue from 'vue'

const defaultClasses = 'br-5'

export default Vue.extend({
  props: {
    /**
     * The image object from the vacancy object
     */
    image: {
      type: String,
      required: true,
    },
    /**
     * The alternative text to display for accessibility
     */
    altText: {
      type: String,
      required: true,
    },
    classes: {
      type: String,
      required: false,
      default: defaultClasses,
    },
  },
})
